import { Component, OnInit, Output, EventEmitter, Input, ViewChild, QueryList } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'modal-payment',
    templateUrl: '../../templates/partials/modal-payment.html'
})

export class ModalPaymentComponent implements OnInit {

    @Input() showModal;
    @Input() setPaymentBill;
    @Output() emitCloseModal = new EventEmitter();
    @ViewChild('paymentModal') public paymentModal:ModalDirective;
    constructor() { }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public setBillPayment() {
        this.emitCloseModal.emit({action:"close", data: this.setPaymentBill});
    }

    ngOnChanges(changes: any) {
        (this.showModal) ? this.paymentModal.show() : this.paymentModal.hide();
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/modal-payment.component.ts